import { Platform, View, StyleSheet } from "react-native";
import React from "react";
import RLinkButton from "../../RLink/RLinkButton";
import { logEvent } from "../../../client/analytics/trackPageView";
import variables from "../../../styles/variables";

type Props = {
  text: string;
  link: string;
  backgroundColor: string;
  textColor: string;
  deviceTypes?: Array<string> | null;
};

const CustomHeaderButton = ({
  text,
  link,
  backgroundColor = variables.colors.palette.rtv.secondary,
  textColor = variables.colors.palette.rtv.white,
  deviceTypes,
}: Props) => {
  if (deviceTypes && !deviceTypes.includes(Platform.OS)) return null;
  if (!link || !text) return null;

  return (
    <RLinkButton
      slug={link} // assumes link is a slug currently
      text={text}
      backgroundColor={backgroundColor}
      textColor={textColor}
      dataSetButton={{ id: "custom-header-button" }}
      dataSetButtonText={{ id: "custom-header-button-text" }}
      onPressCallback={() => {
        logEvent({
          key: `custom-header-${text?.split(" ")?.join("-")?.toLowerCase()}`,
          data: {},
        });
      }}
      style={styles.button}
    />
  );
};

const styles = StyleSheet.create({
  button: {
    display: "flex", //this is needed for web
    alignItems: "center",
  },
});

export default CustomHeaderButton;
